import axios from "axios";
import { Route, Routes } from "react-router-dom";
import { AuthRedirect } from "@/pages/auth/AuthRedirect";
import AppShell from "@/components/layouts/AppShell";
import SideBar from "@/components/sidebars/SideBar";
import { useAuth } from "@/context/providers/AuthProvider";
import ChangePassword from "@/pages/auth/ChangePassword";
import OTPScreen from "@/pages/auth/OTPScreen";
import { ERROR_CODES } from "@/utils/constants/constants";
import { getCurrentOrganization } from "@/utils/functions/OrganizationFunctions";
import { getToken } from "@/utils/functions/TokenFunction";
import { infoToasterMessage } from "@/utils/functions/toaster";
import SideBarRoutes from "@/routes/SideBarRoutes";
import AdLoginScreen from '@/pages/auth/LoginScreens/AdLoginScreen';
import LoginMain from "@/pages/auth/LoginScreens/LoginMain";
import Password from "@/pages/auth/LoginScreens/Password";
import DirectoryServiceSuccess from "@/pages/directoryservice/DirectoryServiceSuccess";
import ConsentScreen from "@/pages/auth/ConsentScreen";
import ValidateLoggedInUser from "@/pages/auth/ValidateLoggedInUser";
import { ErrorMismatch } from "@/pages/auth/ErrorMismatch";

const AppRoutes = () => {
    const { clearToken, token } = useAuth();

    /**
     * interceptor to add X-Organization header to all requests
     */
    axios.interceptors.request.use((config) => {
        const currentOrganization = getCurrentOrganization();
        if (currentOrganization?.organization) {
            config.headers["X-Organization"] = currentOrganization?.organization;
        } else {
            config.headers["X-Organization"] = "";
        }
        return config;
    });
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (error?.response?.status === 403 && error?.response?.data?.error_code === ERROR_CODES.IP_WHITELISTING_ERROR_CODE) {
                if (getToken()) {
                    clearToken();
                    localStorage.clear();
                    window.history.replaceState(null, '', '/');
                }
                infoToasterMessage(error?.response?.data?.message);
            } else if (error?.response?.status === 401) {
                if (getToken()) {
                    clearToken();
                    localStorage.clear();
                    window.history.replaceState(null, '', '/');
                }
            }
            
            return Promise.reject(error);
        }
    );

    const loggedInRoutes = [
        <Route
            key="/*"
            path="/*"
            element={
                <AppShell sidebar={<SideBar />}>
                    <SideBarRoutes />
                </AppShell>
            }
        />,
        <Route key={"/change-password"} path="/change-password" element={<ChangePassword />} />,
        <Route key={"/login"} path="/login" element={<AdLoginScreen />} />,
        <Route key="/validate-user" path="/validate-user" element={<ValidateLoggedInUser />} />,
        <Route key={"/verify-otp"} path="/verify-otp" element={<OTPScreen />} />,
    ];

    const loggedOutRoutes = [<Route key="/*" path="/*" element={<LoginMain />} />, <Route key={"/otp"} path="/otp" element={<OTPScreen />} />,<Route key={"/login"} path="/login" element={<Password />} />];

    return (
        <Routes>
            <Route key="/auth/:id" path="/auth/:id" element={<AuthRedirect />} />
            <Route key="/directory-success" path="/directory-success" element={<DirectoryServiceSuccess />} />
            <Route key="/consent" path="/consent" element={<ConsentScreen />} />
            <Route key="/email-mismatch" path="/email-mismatch" element={<ErrorMismatch />} />
            {token ? loggedInRoutes : loggedOutRoutes}
        </Routes>
    );
};

export default AppRoutes;
